import { render, staticRenderFns } from "./batchOperation.vue?vue&type=template&id=0d971d82&scoped=true&"
import script from "./batchOperation.vue?vue&type=script&lang=js&"
export * from "./batchOperation.vue?vue&type=script&lang=js&"
import style0 from "./batchOperation.vue?vue&type=style&index=0&id=0d971d82&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d971d82",
  null
  
)

export default component.exports